var exports = {
  "k": "x14bf3cd8--b744ef--container",
};

module.exports = exports;
